<template>
  <button 
    v-if="scrollD"
    class="fixed right-16 bottom-16 text-5xl cursor-pointer text-nosotrxs-basetext
    active:text-nosotrxs-basetext hover:text-header-hovertext focus:outline-none"
    @click="toTop"
  >
    <slot> </slot>
  </button>
</template>

<script>
export default {
    data() {
        return {
            scrollD: false    
        }
    },
    mounted() {
        window.addEventListener('scroll', this.showButton)
    },
    created(){
        
    },
    methods: {
        showButton() {
            if (scrollY>300)
                this.scrollD = true 
            else if (scrollY<=300)
                this.scrollD = false 
        },
        toTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            })
        }
    }
}
</script>

<style>

</style>